import React        from 'react'
import { connect }  from 'react-redux'
import { withRouter } from "react-router-dom"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import i18n         from '../../../i18n'
import {mapDispatchToProps} from "../../mapDispatchToProps"

class ConfirmReLogin extends React.PureComponent{
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }

  handleSubmit() {
    localStorage.removeItem('mf_authorization');
    localStorage.removeItem('oauth_authorize');
    localStorage.removeItem("refererUrl")
    this.props.sessionActions.defaultSession({isFetchingSession: false})
    window.location.href = this.props.location.pathname
  }

  handleCancel() {
    this.props.toggle()
    this.props.history.replace('/bank')
  }

  username() {
    return (
      <span style={{color: 'rgba(0, 0, 0, 0.5)'}}>
        {this.props.email.split('@')[0]}
      </span>
    )
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} className={this.props.className} centered={true}>
        <ModalHeader toggle={this.handleCancel}>ログインセッションが異なります</ModalHeader>
        <ModalBody>
          <div>
            選択した口座は現在ログイン中の {this.username()} で連携した口座ではありません。<br/><br/>
            一度ログアウトし、選択した口座の連携時に使用したメールアドレスでログアウトしてください。<br/><br/>
            ログアウトしますか？
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.handleCancel} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
          <button className="btn mfc-btn-red medium" type="submit" onClick={this.handleSubmit}>
            {i18n.t('header.logout')}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ConfirmReLogin))
